export default function Footer() {
  return (
  <>
    <footer class="site-footer">
  <div class="container">

    <div class="footer-grid">

      
      <div class="footer-column">
        <h3>Technosolve Consultants LLP</h3>
        <p>
          B2, 2nd Floor, Plot #137,
          The Bird's Angle, 3rd Main Road,
          Sai Ganesh Nagar,
          Pallikaranai, Chennai – 600100
        </p>
        <p>
          <strong>Phone:</strong> <a href="tel:9884440598">98844 40598</a>
          <strong>Email:</strong> <a href="mailto:sales@technosolve.co">sales@technosolve.co</a>
        </p>
      </div>

      
      <div class="footer-column">
        <h3>Pudukkottai</h3>
        <p>
          First Floor, TSR Complex,
          Kothamangalam (PO),
          Alangudi (TK),
          Pudukkottai (DT) – 614624
        </p>
        <p>
        <strong>Phone:</strong> <a href="tel:9123549624">9123549624</a>
          <strong>Email:</strong> <a href="mailto:sales@technosolve.co">sales@technosolve.co</a>
        </p>
      </div>

      
      <div class="footer-column">
        <h3>Coimbatore</h3>
        <p>
          D2B, Isha Armonia,<br/>
          Visweswara Nagar,<br/>
          Vilankurichi Main Road,<br/>
          Coimbatore – 641035
        </p>
        <p>
        <strong>Phone:</strong> <a href="tel:9789887598">9789887598</a><br/>
          <strong>Email:</strong> <a href="mailto:sales@technosolve.co">sales@technosolve.co</a>
        </p>
      </div>

      
      <div class="footer-column">
        <h3>Working Hours</h3>
        <p>
          <strong>Mon – Fri:</strong> 9:00 AM – 6:00 PM<br/>
          <strong>Saturday:</strong> 9:00 AM – 1:00 PM<br/>
          <strong>Sunday:</strong> Weekly Off
        </p>
        
        
                    
      </div>

    </div>

    <div class="footer-bottom">
    <p>With ❤️ From <a href="https://www.technosolve.co" target="_blank" style={{ color:"#FFFFFF" }}>Technosolve</a></p>
      
      
      
    </div>

  </div>
</footer>

<a href="https://wa.me/919884440598" class="whatsapp-float" target="_blank">
<img src="images/WhatsApp.svg" />
</a>
</>
  );
}
